import { isFeedieEmail } from '@feedyou/utils'
import { UserRole, UserEmail } from '@feedyou-ai/feedbot-schema'

export function getTooltipText(
  name: string = '',
  role: 'guest' | UserRole | 'admin' | '' = '',
  email: UserEmail = '',
  isEditing: boolean = false,
  connected?: boolean
): string | JSX.Element {
  if (connected === false) {
    return `${name} • offline`
  }

  if (isEditing) {
    return `${name} • editing`
  }

  if (role) {
    const isFeedyouAdminUser = isFeedieEmail(email) && role === 'admin'
    const roleInfo = isFeedyouAdminUser ? <>feedyou&nbsp;{role}</> : role
    return (
      <>
        {name} • {roleInfo}
      </>
    )
  }

  return ''
}
